<div #top class="container">
  <div class="download-banner">
    <app-download-banner></app-download-banner>
  </div>

  <!-- P8: whole heading bold + single-tone, like its sibling list headings
       (see advanced-search-result.component.css). -->
  <h3>
    Advanced
    <span>Search Results</span>
  </h3>

  <app-shortcuts
    *ngIf="shortcuts && shortcuts.length > 0"
    [searchShortcuts]="shortcuts"
    [fromSearch]="true"
    [searchValue]="searchValue"
    [upScroll]="upScroll"
    (detectUpdates)="detectUpdates()"
  ></app-shortcuts>

  <app-templates
    *ngIf="plates && plates.length > 0"
    [searchPlates]="plates"
    [fromSearch]="true"
    [searchValue]="searchValue"
    [downScroll]="downScroll"
    (detectUpdates)="detectUpdates()"
  ></app-templates>

  <!-- No-results state: illustration, then the big "Whoops!" title UNDER it,
       then the message. Deliberately NOT the global `.empty-state` class — that
       one is the sprite-based placeholder (fixed 200px tall, `svg` rules) used
       by the FlyCuts/FlyShare lists, and it fought this image + 36px title.
       Styles live in the component CSS; the old copy carried the whole layout
       inline, including a `width: 100vw` that overflowed the container. -->
  <div class="search-empty" *ngIf="noResults">
    <img class="search-empty__image" src="assets/images/Error.png" alt="" />
    <h1 class="search-empty__title">Whoops!</h1>
    <p class="search-empty__message">We couldn’t find any FlyPlates or FlyCuts with this search criteria.</p>
    <p class="search-empty__message">Want to try a different search?</p>
  </div>
</div>
